import React, { useEffect, useState } from 'react'

import { useQuery, useLazyQuery } from '@apollo/react-hooks'
import { GET_LOCATION_INFO, GET_TRAVELTIME2 } from 'operations/Location'

import './location.scss'
import { camelCase } from 'lodash'
import Loader from 'components/Loader'
import { polygonStyles } from 'config'

export default function({ locationId: id, pin, onFetchTravelTime, map, onFetchCircle }) {

    const { error, loading, data } = useQuery(GET_LOCATION_INFO, { variables: { id }, skip: pin })
    const [ getTravelTime, { data: travelTimeData, loading: travelTimeLoading } ] = useLazyQuery(GET_TRAVELTIME2)

    const [ expanded, setExpanded ] = useState(false)

    const [ getNearby, setGetNearby ] = useState(false)

    const [ travelTime, setTravelTime ] = useState(3600)

    const [ nearbyType, setNearbyType ] = useState('DISTANCE')
    const [ distance, setDistance ] = useState(50)

    useEffect(() => {
        if (travelTimeData && travelTimeData.travelTime2) {
            onFetchTravelTime({ result: travelTimeData.travelTime2, error: typeof travelTimeData.travelTime2 === 'string', travelTime })
        }
        // eslint-disable-next-line
    }, [travelTimeData])

    return (
        <>
            <div className={`location__container ${ expanded ? 'location__container--expanded' : '' } ${ data && data.location ? `location__container--${ camelCase(data.location.channelSegment) }` : '' }`}>
                {
                    loading && 'Loading...'
                }
                {
                    error && 'Error :('
                }
                {
                    !loading && !error && data && data.location && (
                        <>
                            <div className='location__header'>
                                <div className='location__companyName'>{ data.location.companyName }</div>
                                <div className='location__header__right'>
                                    <button type='button' className='location__pin' title='Re-center' onClick={() => {
                                        map.panTo({ lat: data.location.latitude, lng: data.location.longitude })
                                    }}><i className='material-icons'>my_location</i></button>
                                    <button type='button' className={`location__expander location__expander--${ expanded ? 'down' : 'up' }`} onClick={() => setExpanded(!expanded)}><i className='material-icons'>keyboard_arrow_up</i></button>
                                </div>
                            </div>
                            <div className='location__actions'>
                                <LocationButton onClick={() => {

                                    setGetNearby(!getNearby)

                                    // getTravelTime({
                                    //     variables: {
                                    //         payload: {
                                    //             origin: {
                                    //                 lat: data.location.latitude,
                                    //                 lng: data.location.longitude
                                    //             },
                                    //             mode: 'drive',
                                    //             time: travelTime,
                                    //             congestion: false
                                    //         }
                                    //     }
                                    // })

                                }} className={ data && data.location ? `locationButton--${ camelCase(data.location.channelSegment) }` : '' } icon='sensors'>Nearby</LocationButton>
                            </div>
                            <div className='location__details'>
                                <div className='location__details__address'>
                                    { data.location.address }, { data.location.city }, { data.location.provinceCode } { data.location.postal }
                                </div>
                            </div>
                        </>
                    )
                }
            </div>
            { travelTimeLoading && <Loader>Loading the space-time continuum...</Loader> }
            {
                getNearby && (
                    <div className='travelTime__container'>
                        <div className='travelTime'>
                            <h1>Nearby locations</h1>

                            <div className='nearbyTypeContainer'>
                                <button type='button' className={`nearbyToggle nearbyToggle--left ${ nearbyType === 'DISTANCE' ? 'nearbyToggle--active' : '' }`} onClick={() => setNearbyType('DISTANCE')}>Distance</button>
                                <button type='button' className={`nearbyToggle nearbyToggle--right ${ nearbyType === 'TIME' ? 'nearbyToggle--active' : '' }`} onClick={() => setNearbyType('TIME')}>Travel Time</button>
                            </div>

                            {
                                nearbyType === 'TIME' && (
                                    <>
                                        <input className='range' type='range' min='300' max='7200' step='300' value={travelTime} 
                                            onChange={({ target: { value } }) => { setTravelTime(value); } }
                                        />
                                        <div className='rangeContainer'>Range: <ConvertTime>{travelTime}</ConvertTime></div>
                                        <button type='button' className='nearbySearchButton' onClick={() => {
                                            setGetNearby(false)
                                            getTravelTime({
                                                variables: {
                                                    payload: {
                                                        origin: {
                                                            lat: data.location.latitude,
                                                            lng: data.location.longitude
                                                        },
                                                        mode: 'drive',
                                                        time: parseInt(travelTime, 10),
                                                        congestion: false
                                                    }
                                                }
                                            })
                                        }}>Search</button>
                                    </>
                                )
                            }
                            {
                                nearbyType === 'DISTANCE' && (
                                    <div>
                                        <input className='range' type='range' min='1' max='250' step='1' value={distance} 
                                            onChange={({ target: { value } }) => { setDistance(value); } }
                                        />
                                        <div className='rangeContainer'>Range: { distance } km</div>
                                        <button type='button' className='nearbySearchButton' onClick={() => {
                                            setGetNearby(false)

                                            const google = window.google

                                            const radius = new google.maps.Circle({
                                                ...polygonStyles,
                                                map: map,
                                                center: { lat: data.location.latitude, lng: data.location.longitude },
                                                radius: distance * 1000
                                            })
                                            onFetchCircle({ result: radius, distance })
                                        }}>Search</button>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                )
            }
        </>
    )
}

export function LocationContainer({ onFetchTravelTime, pin, map }) {

    const [ getTravelTime, { data: travelTimeData, loading: travelTimeLoading } ] = useLazyQuery(GET_TRAVELTIME2)

    const [ expanded, setExpanded ] = useState(false)

    const [ getNearby, setGetNearby ] = useState(false)

    const [ travelTime, setTravelTime ] = useState(3600)

    useEffect(() => {
        if (travelTimeData && travelTimeData.travelTime2) {
            onFetchTravelTime({ result: travelTimeData.travelTime2, travelTime })
        }
        // eslint-disable-next-line
    }, [travelTimeData])

    return (
        <>
            <div className={`location__container ${ expanded ? 'location__container--expanded' : '' }`}>
                <div className='location__header'>
                    <div className='location__companyName'>{ pin.place.description }</div>
                    <div className='location__header__right'>
                        <button type='button' className='location__pin' title='Re-center' onClick={() => {
                            map.panTo({ lat: pin.location.lat, lng: pin.location.lng })
                        }}><i className='material-icons'>my_location</i></button>
                        <button type='button' className={`location__expander location__expander--${ expanded ? 'down' : 'up' }`} onClick={() => setExpanded(!expanded)}><i className='material-icons'>keyboard_arrow_up</i></button>
                    </div>
                </div>
                <div className='location__actions'>
                    <LocationButton onClick={() => {

                        setGetNearby(!getNearby)

                        // getTravelTime({
                        //     variables: {
                        //         payload: {
                        //             origin: {
                        //                 lat: data.location.latitude,
                        //                 lng: data.location.longitude
                        //             },
                        //             mode: 'drive',
                        //             time: travelTime,
                        //             congestion: false
                        //         }
                        //     }
                        // })

                    }} icon='sensors'>Nearby</LocationButton>
                </div>
            </div>
            { travelTimeLoading && <Loader>Loading the space-time continuum...</Loader> }
            {
                getNearby && (
                    <div className='travelTime__container'>
                        <div className='travelTime'>
                            <h1>Drive time</h1>
                            <input className='range' type='range' min='300' max='3600' step='300' value={travelTime} 
                                onChange={({ target: { value } }) => { setTravelTime(value); } }
                            /><ConvertTime>{travelTime}</ConvertTime>
                            <button type='button' onClick={() => {
                                setGetNearby(false)
                                getTravelTime({
                                    variables: {
                                        payload: {
                                            origin: {
                                                lat: pin.location.lat,
                                                lng: pin.location.lng
                                            },
                                            mode: 'drive',
                                            time: parseInt(travelTime, 10),
                                            congestion: false
                                        }
                                    }
                                })
                            }}>Search</button>
                        </div>
                    </div>
                )
            }
        </>
    )
}

function LocationButton({ children, onClick, className, icon }) {
    return (
        <button type='button' className={`locationButton ${ className }`} onClick={() => onClick && onClick()}><i className='material-icons'>{ icon }</i>{ children }</button>
    )
}

function ConvertTime({ children }) {
    const minutes = Math.floor(children / 60)
    const hours = Math.floor(minutes / 60)

    return <>{ hours > 0 && hours + ' hour' }{ hours > 1 && 's' } { minutes - ( hours * 60 ) } minutes</>

}